import React from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';

export default injectIntl(({ ...props }) => (
  props.id ? <FormattedMessage {...props} /> : null
));
